import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import StagedRolloutStore from "@shared/svelte/Stores/StagedRolloutStore";
import StateSettingsStore from "@shared/svelte/Stores/StateSettingsStore";
import type { CartOrderType } from "@shared/types/Cart";
import { get as getStoreValue } from "svelte/store";
import { isRestrictedRole } from "./preview_forbidden_flash";

export const loadFuturePrices = async (FuturePricesStore, orders: CartOrderType[]) => {
  let res = await HttpPromise({
    method: "GET",
    url: "/api/retailer/state_settings",
  });
  StateSettingsStore.set(res);
  const stateSettings = getStoreValue(StateSettingsStore);

  const usesFuturePricingWithMinBottle = stateSettings
    ? stateSettings["uses_future_pricing_with_min_bottle"]
    : false;
  const usesFuturePricing = stateSettings ? stateSettings["uses_future_pricing"] : false;

  orders.forEach(
    async (order: CartOrderType) =>
      await loadFuturePricesForOrder(
        FuturePricesStore,
        order,
        getStoreValue(StagedRolloutStore),
        usesFuturePricing,
        usesFuturePricingWithMinBottle,
      ),
  );
};

const loadFuturePricesForOrder = async (
  FuturePricesStore,
  order: CartOrderType,
  rollouts,
  usesFuturePricing: boolean,
  usesFuturePricingWithMinBottle: boolean,
) => {
  const showFuturePricing =
    order.distributor?.seven_fifty_integration &&
    (usesFuturePricing || usesFuturePricingWithMinBottle);

  if (!showFuturePricing || !usesFuturePricingWithMinBottle) {
    return;
  }

  if (
    !rollouts["future_pricing"] ||
    isRestrictedRole(["supplier"]) ||
    !order.distributor ||
    !order.distributor.seven_fifty_integration ||
    order.products.length === 0
  ) {
    return;
  }

  await HttpPromise({
    method: "GET",
    url: `/api/retailer/future_prices`,
    data: {
      inventory_ids: order.products.map(product => product.inventory_id),
      distributor_id: order.distributor.id,
    },
  }).then(res => {
    FuturePricesStore.update(futurePrices => [...res.future_prices, ...futurePrices]);
  });
};
